import React from 'react';
import {injectIntl, intlShape} from 'react-intl';

import classnames from 'classnames';
import {EmptyFunc} from 'utils/DBUtils.js';
import AutoSaveField from './abstract/AutoSaveField.jsx';
import {isNoU} from "../../../utils/DBUtils";
import OnBlurTextArea from "../BasicFormFields/OnBlurTextArea";

class AutoSaveTextArea extends React.Component {
    static defaultProps = {
        onValidationError: EmptyFunc,
        onValidationSuccess: EmptyFunc
    };

    constructor(props) {
        super(props);
        let value = props.defaultValue || '';
        this.state = {
            value: value,
            isValid: true,
            textLength: value.length
        };
    }

    getValueFromOnChange = (event, data) => {
        const value = event.target.value || '';
        this.setState({
            value,
            isValid: true,
            textLength: value.length
        });
        return value;
    };

    onValidationError = (name, failedRules) => {
        this.props.onValidationError(name, failedRules);
        if (this.state.isValid) {
            this.setState({isValid: false});
        }
    };

    onValidationSuccess = (name) => {
        this.props.onValidationSuccess(name);
        this.setState({isValid: true});
    };

    onValueChanged = (value, field) => {
        let modValue = value;
        if (this.props.asList) {
            modValue = value.split(',').filter((item) => !isNoU(item) && item.trim() !== '');
        }

        this.props.onValueChanged(modValue, field);
    };

    get hasValidDefaultValue() {
        return !isNoU(this.props.defaultValue) && String(this.props.defaultValue).trim() !== "";
    }

    commaListValue() {
        return isNoU(this.props.defaultValue)
            ? ""
            : Array.isArray(this.props.defaultValue)
                ? this.props.defaultValue.join(',')
                : this.props.defaultValue;
    }

    onTextLengthChange = (len) => {
        this.setState({
            textLength: len
        })
    };

    render() {
        // Need a more specific error class so we don't say .error .ui.form textarea since that will also highlight this if the accordion has .error
        return (
            <div className={classnames({error: !this.state.isValid, 'textarea-error': !this.state.isValid})}>
              <AutoSaveField
                control={OnBlurTextArea}
                getValueFromOnChange={this.getValueFromOnChange}
                validationRules={this.props.validationRules}
                supportsLoading={true}
                placeholder={this.props && this.props.placeholderKey ? this.props.intl.formatMessage({ id: this.props.placeholderKey})  : ""}
                {...this.props}
                defaultValue={this.props.asList ? this.commaListValue() : this.props.defaultValue ? this.props.defaultValue : this.props.linkedValue}
                onValidationError={this.onValidationError}
                onValidationSuccess={this.onValidationSuccess}
                onPersistValue={this.onValueChanged}
                getTextLengthCallback={this.onTextLengthChange}
                usingLinkedValue={!this.hasValidDefaultValue}
                spellCheck={true}
               />

              { this.props.maxLength ?
                <div className='textarea-feedback'>
                  {this.state.value ? this.state.textLength : (this.props.linkedValue ? this.props.linkedValue.length : 0)}/{this.props.maxLength}
                </div>
              : "" }
              {/* maxLengthHint shows the length but does not limit the value */}
              { this.props.maxLengthHint ?
                <div className='textarea-feedback'>
                  {this.state.value ? this.state.textLength : (this.props.linkedValue ? this.props.linkedValue.length : 0)}/{this.props.maxLengthHint}
                </div>
              : "" }
            </div>
        );
    }
}

export default injectIntl(AutoSaveTextArea);

AutoSaveTextArea.propTypes = {
  intl: intlShape.isRequired
};



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveTextArea.jsx